import script from "./ManagePresence.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePresence.vue?vue&type=script&setup=true&lang=js"

import "./ManagePresence.vue?vue&type=style&index=0&id=66c13c3d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c13c3d"]])

export default __exports__